import Spinner from 'src/javascripts/components/utilities/Spinner';
import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import ManualListTypeahead from 'src/javascripts/components/typeaheads/ManualListTypeahead';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import Swal from 'sweetalert2';

import AddDocuments from './functions/AddDocuments';
import AddSupportingLinks from './functions/AddSupportingLinks';
import CheckValidationsOnSubmit from './functions/CheckValidationsOnSubmit';
import CheckValidationsOnInput from './functions/CheckValidationsOnInput';
import DisableUnchangedFields from './functions/DisableUnchangedFields';
import EnableUnchangedFields from './functions/EnableUnchangedFields';
import SaveBeforeQuestionGroupNav from './functions/SaveBeforeQuestionGroupNav';
import FillDownColumn from './functions/FillDownColumn';
import QuestionDropdown from './functions/QuestionDropdown';
import RemoveMultiOption from './functions/RemoveMultiOption';
import SelectExistingDocument from './functions/SelectExistingDocument';
import SetManualTypeahead, { closeFloatingTypeaheadsWithin } from './functions/SetManualTypeahead';
import SetMultiDropdown from './functions/SetMultiDropdown';
import SetUpdatedAtCols from './functions/SetUpdatedAtCols';
import ToggleNewData from './functions/ToggleNewData';
import UpdateConditionals from './functions/UpdateConditionals';
import UpdateCalculated from './functions/UpdateCalculated';
import UpdateTotals from './functions/UpdateTotals';
import UpdateCollectionType from './functions/UpdateCollectionType';
import UpdateProgressBar, { initializeProgressTracking } from './functions/UpdateProgressBar';
import ApplyHistoricalAnswer from './functions/ApplyHistoricalAnswer';

import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default function(parentContainerId = null) {
  const accountUrl = $('body').attr('data-account-url');
  const surveySlug = $('.polling-indicator').attr('data-slug');

  // Set parent container to scope code to
  let parentContainerEl;
  if (parentContainerId === null) {
    parentContainerEl = 'body';
  } else {
    parentContainerEl = '#' + parentContainerId;
  }
  let parentContainer = $(parentContainerEl);

  // Format display numbers in form
  NumberDisplay();

  // Save before navigating between question groups
  SaveBeforeQuestionGroupNav(parentContainer);

  // Run remove option initially
  RemoveMultiOption();

  // Apply a row to all others
  parentContainer.find('.apply-row-to-all').click(function() {
    $(this).closest('tr').find('td').each(function(index) {
      let input = $(this).find('input.answer-text');
      let select = $(this).find('select.answer-text');
      if (input.length !== 0) {
        let val = input.val();
        $(this).closest('tbody').find('tr').each(function() {
          let relatedTd = $(this).find('td')[index];
          let input = $(relatedTd).find('input.answer-text')
          input.val(val);
          $(relatedTd).find('.twitter-typeahead input').val(val);
          ToggleNewData(input);
          SetUpdatedAtCols(input);
        })
      } else if (select.length !== 0) {
        let val = select.val();
        $(this).closest('tbody').find('tr').each(function() {
          let relatedTd = $(this).find('td')[index];
          let select = $(relatedTd).find('select.answer-text')
          select.val(val).trigger('change');
          $(relatedTd).find('.twitter-typeahead input').val(val);
          ToggleNewData(select);
          SetUpdatedAtCols(select);
        })
      }
    });
  });

  // Manual list typeaheads
  if (parentContainer.find('.manual-list-typeahead').length !== 0) {
    // A floated menu (ET-3185) lives outside this subtree in document.body;
    // close it first so destroy() doesn't orphan it there.
    closeFloatingTypeaheadsWithin(parentContainer[0]);
    parentContainer.find('.manual-list-typeahead').typeahead('destroy');
    parentContainer.find('.manual-list-typeahead').each(function(el){
      let id = $(this).attr('id');
      let t = new ManualListTypeahead(el);
      t.render(id)
    });
  }

  // Manual list typeaheads - multiple selection allowed
  SetMultiDropdown(parentContainer);

  // Allow users to apply a historical answer to the current field
  ApplyHistoricalAnswer(parentContainer);

  // On selecting a typeahead answer, clear the field
  parentContainer.find('.typeahead.answer-text')
    .off('click.clearTypeahead')
    .on('click.clearTypeahead', function() {
    let ig = $(this).closest('td');
    if (ig.length === 0) {ig = $(this).closest('.input-group')}
    let answerText = ig.find('input.answer-text').first();
    let tp = ig.find('.typeahead');
    const currentVal = (answerText.val() || '').toString();
    if (currentVal.trim().length > 0) {
      answerText.data('skipValidation', true).val('').trigger('change');
    }
    tp.css('background', '').removeClass('no-asc no-desc yes-asc yes-desc information-not-available filled');
    $(this).typeahead('val', '');
    $(this).focus();
  });

  // On update text field or textarea
  parentContainer.find('input, textarea').blur(function() {
    // Skip typeahead hint inputs (read-only hints that mirror the input)
    if ($(this).hasClass('tt-hint')) {
      return;
    }

    let val = $(this).val();
    let answerText = $(this).closest('.input-group').find('.answer-text').val();
    $(this).css('background', '').removeClass('no-asc no-desc yes-asc yes-desc information-not-available filled');
    let metricDir = $(this).attr('data-metric-direction');
    let cell = $(this).closest('.survey-table-cell');
    if (typeof metricDir === 'undefined') {metricDir = ''};
    if ((val === "Yes") && (metricDir !== '')) {
      $(this).addClass('yes-' + metricDir);
    } else if ((val === "No") && (metricDir !== '')) {
      $(this).addClass('no-' + metricDir);
    } else if ((val === "High") && (metricDir !== '')) {
      $(this).addClass('high-' + metricDir);
    } else if ((val === "1: High Risk")) {
      $(this).addClass('low-desc');
    } else if ((val === "Red")) {
      $(this).addClass('low-desc');
    } else if ((val === "Low") && (metricDir !== '')) {
      $(this).addClass('low-' + metricDir);
    } else if ((val === "3: Low Risk")) {
      $(this).addClass('medium');
    } else if ((val === "Medium") && (metricDir !== '')) {
      $(this).addClass('medium');
    } else if ((val === "2: Medium Risk")) {
      $(this).addClass('medium');
    } else if ((val === "Yellow")) {
      $(this).addClass('medium');
    } else if ((val === "4: Neutral")) {
      $(this).addClass('medium');
    } else if ((val === "5: Positive Impact")) {
      $(this).addClass('high-desc');
    } else if ((val === "Green")) {
      $(this).addClass('high-desc');
    } else if (val === "Information not available") {
      $(this).addClass('information-not-available');
    } else if (val.length > 0) {
      $(this).addClass('filled');
    } else if ((typeof answerText !== 'undefined') && (answerText.length > 0)) {
      $(this).addClass('filled');
    }
    if (typeof cell !== 'undefined') {
      cell.addClass('completed');
    }
    if ((typeof answerText !== 'undefined') && (answerText.length > 0)) {
      $(this).closest('.question-row').removeClass('incomplete');
    }
    CheckValidationsOnInput($(this), val);
    UpdateTotals($(this));
    UpdateProgressBar(this);

  });

  // On edit long text modal
  parentContainer.find('.long-text-modal').on('hidden.bs.modal', function(e) {
    let val = $(this).find('textarea').val();
    if (val.length > 0) {
      $(this).closest('td').find('.add-long-text-modal').addClass('bg-a-rating').empty().append("Edit...")
    } else {
      $(this).closest('td').find('.add-long-text-modal').removeClass('bg-a-rating').empty().append("Add...");
    }
  })

  // Indicate value changed on update
  parentContainer.find('input, textarea').keyup(function() {
    let el = $(this);
    ToggleNewData(el);
  });

  // Indicate value changed on update
  parentContainer.find('select:not(.cell-dropdown-option)').change(function() {
    let el = $(this);
    ToggleNewData(el);
    UpdateTotals(el);
    UpdateProgressBar(this);
  });

  // Update dependent dropdowns on select
  parentContainer.find('select.cell-dropdown-option').change(function() {
    let el = $(this);
    ToggleNewData(el);

    // Update associated updated at/by cols if present
    SetUpdatedAtCols(el);
    UpdateTotals(el);
    UpdateProgressBar(this);
  });

  // If value has changed, set collection type to survey
  parentContainer.find('input, textarea, select').change(function() {
    UpdateCollectionType($(this));
  });

  // If companies search included
  if (parentContainer.find('#companies_search').length !== 0) {
    let el = $('#companies_search')
    let token = el.data('survey-token');
    filterTypeahead('#companies_search', 'companies', '/' + accountUrl + '/companies/search?survey_token=' + token, 382, 'logo');
    ToggleNewData(el);
    el.bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      el.closest('.input-group').find('.answer-text').val(suggestion.name).trigger('change');
    })
  }

  // Update associated updated at/by cols if present
  parentContainer.find('td input, td textarea').keyup(function() {
    let el = $(this);
    SetUpdatedAtCols(el);
  });

  // Check conditionals on blur of field with conditions - inputs and textareas
  parentContainer.find('.input-group[data-has-dependencies=\'true\'').find('input:not(.typeahead), textarea').blur(function() {
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let ig = $(this).closest('.input-group');
    if (valsChanged.length > 0) {
      UpdateConditionals(ig, $(this).val());
      UpdateProgressBar(this);
    }
  });

  // Also check conditionals on change for answer-text inputs.
  parentContainer.find('.input-group[data-has-dependencies=\'true\']').find('input.answer-text, textarea.answer-text').change(function() {
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let ig = $(this).closest('.input-group');
    if (valsChanged.length > 0) {
      UpdateConditionals(ig, $(this).val());
      UpdateProgressBar(this);
    }
  });

  // Check calculated fields on blur of field with calculations - inputs and textareas
  parentContainer.find('.input-group[data-has-calculations=\'true\'').find('input:not(.typeahead), textarea').blur(function() {
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let ig = $(this).closest('.input-group');
    if (valsChanged.length > 0) {
      UpdateCalculated(ig, $(this).val());
    }
  });

  // Save on blur of field with conditions - select fields
  parentContainer.find('.input-group[data-has-dependencies=\'true\']').find('select').change(function() {
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let ig = $(this).closest('.input-group');
    if (valsChanged.length > 0) {
      UpdateConditionals(ig, $(this).val());
      UpdateProgressBar(this);
    }
  });

  // Save on blur of field with calculations - select fields
  parentContainer.find('.input-group[data-has-calculations=\'true\']').find('select').change(function() {
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let ig = $(this).closest('.input-group');
    if (valsChanged.length > 0) {
      UpdateCalculated(ig, $(this).val());
    }
  });

  // Confirm pre-filled answers
  $('.confirm-prefilled').on('click', function() {
    let cont = $(this).closest('.confirm-prefilled-container');
    let hiddenField = $(this).closest('.question-row').find('.hidden-prefill-confirmed');
    let newDataField = $(this).closest('.question-row').find('.new-data');
    hiddenField.val(true);
    newDataField.val(true);
    cont.remove();
    $('#saveSurvey').click();
    ToastCustom({title: 'Answer Confirmed', message: 'Answer confirmed. You may still change the answer or add commentary, supporting documents or links'});
  })

  // Set manual list typeahead
  SetManualTypeahead(parentContainer);

  // Initialize progress tracking state for all answer inputs
  // This must happen AFTER typeahead initialization (which may transform elements)
  // but before any user interaction
  initializeProgressTracking();

  // Reconcile visible conditional rows/tables immediately on load so the
  // progress bar does not wait for the next poll cycle to correct itself.
  UpdateProgressBar();

  // Set question dropdowns
  QuestionDropdown(parentContainer);

  // Check numeric values
  $('.decimal-field').on('input', function() {
    let value = $(this).val();
    let decimalCount = (value.split('.').length - 1);
    let allowedDecimals = parseInt($(this).data('allowed-decimals'), 10);
    if (Number.isNaN(allowedDecimals)) {
      allowedDecimals = 2;
    }
    // Check if the input is numeric or decimal
    if (!$.isNumeric(value) || decimalCount > 1) {
      // If not, remove the last character
      $(this).val(value.slice(0, -1));
      return;
    }
    if (decimalCount === 1) {
      let parts = value.split('.');
      if (allowedDecimals === 0) {
        $(this).val(parts[0]);
        return;
      }
      if (parts[1].length > allowedDecimals) {
        parts[1] = parts[1].slice(0, allowedDecimals);
        $(this).val(parts.join('.'));
      }      
    }
  })
  $('.percent-field, .integer-field').on('input', function() {
    let inputValue = $(this).val();
    let numericValue = inputValue.replace(/[^0-9]/g, "");
    $(this).val(numericValue);
  })
  $('.percent-field').on('input', function() {
    let val = $(this).val();
    let intVal = parseInt(val);
    if ((val.length > 0) && (intVal > 100)) {
      $(this).val('');
      ToastCustom({title: 'Value too large', message: 'Value must be less than or equal to 100'});
      $(this).removeClass('filled');
      $(this).focus();
    } else if ((val.length > 0) && (intVal < 0)) {
      $(this).val('');
      ToastCustom({title: 'Value too small', message: 'Value must be greater than or equal to 0'});
      $(this).removeClass('filled');
      $(this).focus();
    }
  })

  // Save on blur of inputs
  parentContainer.find('.survey-table-cell[data-has-totals=\'true\'').find('input, textarea').blur(function() {
    let valsChanged = $(this).closest('.survey-card-body[data-val-changed=true]');
    if (valsChanged.length > 0) {
      $('#hiddenSaveSurvey').click();
    }
  });
  parentContainer.find('.survey-table-cell[data-has-totals=\'true\'').find('select').change(function() {
    let valsChanged = $(this).closest('.survey-card-body[data-val-changed=true]');
    if (valsChanged.length > 0) {
      $('#hiddenSaveSurvey').click();
    }
  });

  // Disable inputs if submitted
  let submitted = $('#hidden_status').val();
  let isSubmittedOrApproved = ['approved', 'submitted'].includes(submitted);
  let status = $('.polling-indicator').attr('data-status');
  if (isSubmittedOrApproved) {
    parentContainer.find('input,select,textarea').attr('disabled', true)
      .attr('title', 'Submission successful. Unsubmit to make editable again')
      .tooltip({placement: 'top', trigger: 'hover', delay: { show: 500, hide: 100 }});
    parentContainer.find('.mark-not-applicable').removeClass('mark-not-applicable');
    parentContainer.find('.prefer-not-disclose').removeClass('prefer-not-disclose');
    let sumCont = parentContainer.find('.summernote');
    $.each(sumCont, function() {
      $(this).summernote('disable');
    })
  }

  // On show of pre-fill modal, hide tooltip
  parentContainer.find('.prefill-modal').on('shown.bs.modal', function() {
    $('.tooltip').tooltip('hide');
    $(this).find('textarea').on('focus', function() {
      $('.tooltip').tooltip('hide');
    })
  })
  parentContainer.find('.prefill-modal').on('hidden.bs.modal', function() {
    let val = $(this).find('.answer-commentary').val();
    let iga = $(this).closest('.input-group-append')
    let icon = iga.find('.pre-fill-answer')
    if (val.length > 0) {
      iga.attr('data-original-title', 'Commentary added to this answer');
      icon.addClass('bg-gray200');
    } else {
      iga.attr('data-original-title', 'Add commentary to this answer');
      icon.removeClass('bg-gray200');
    }
  })  

  // Flag for review
  parentContainer.find('.flag-for-review').on('change', function(ev, suggestion) {
    let checked = $(this).is(':checked');
    let hiddenField = $(this).closest('.survey-card-body').find('.hidden-flagged-for-review');
    ToggleNewData($(this));
    if (checked === true) {
      hiddenField.val('true');
      $(this).closest('.question-row').find('.flagged-container').removeClass('d-none');
    } else {
      hiddenField.val('false');
      $(this).closest('.question-row').find('.flagged-container').addClass('d-none');
    }
  })

  // Mark not applicable
  parentContainer.find('.mark-not-applicable').on('change', function(ev, suggestion) {
    let checked = $(this).is(':checked');
    let answerTextField = $(this).closest('.survey-card-body').find('.answer-text');
    ToggleNewData($(this));
    if (checked === true) {
      answerTextField.val('Not applicable');
      answerTextField.addClass('filled').prop('readonly', true).change();
    } else {
      answerTextField
        .val('')
        .css('background', '')
        .removeClass('no-asc no-desc yes-asc yes-desc information-not-available filled')
        .prop('readonly', false)
        .change();
    }
  })

  // Fill down column to subsequent rows
  parentContainer.find('.apply-col-to-subsequent').on('click', function() {
    FillDownColumn($(this));
  });

  const answerTextFields = parentContainer.find('.answer-text');
  const realtimeAnswerFields = answerTextFields
    .not('[type="hidden"]')
    .not('.manual-list-typeahead')
    .not('.manual-list-typeahead-multiple');

  // Run validation feedback after users start typing (skip empty focus events)
  realtimeAnswerFields
    .off('input.checkValidations')
    .on('input.checkValidations', function() {
      const val = $(this).val();
      UpdateProgressBar(this);
      if (!val || !val.toString().trim().length) { return; }
      CheckValidationsOnInput($(this), val);
    });

  // Synchronize mark-not-applicable checkbox when answer field is manually set
  answerTextFields
    .off('change.checkValidations')
    .on('change.checkValidations', function() {
      const el = $(this);
      const skipValidation = el.data('skipValidation');
      if (skipValidation) {
        el.removeData('skipValidation');
      }

      // Always update progress bar, even when skipping validation
      UpdateProgressBar(this);

      if (skipValidation) {
        return;
      }

      let answerText = el.val();
      let cardBody = el.closest('.survey-card-body');
      let notApplicableCheckbox = cardBody.find('.mark-not-applicable');
      if (answerText === 'Not applicable') {
        if (!notApplicableCheckbox.is(':checked')) {
          notApplicableCheckbox.prop('checked', true).change();
        }
      } else {
        if (notApplicableCheckbox.is(':checked')) {
          notApplicableCheckbox.prop('checked', false).change();
        }
      }

      CheckValidationsOnInput($(this), answerText);
    });

  // If a user leaves a field blank, run validation on blur to surface required errors
  answerTextFields
    .off('blur.checkValidations')
    .on('blur.checkValidations', function() {
      CheckValidationsOnInput($(this), $(this).val());
    });

  // Synchronize mark-not-applicable checkbox when manual typeahead is opened
  parentContainer.find('.manual-list-typeahead').off('click.gridNav').on('click.gridNav', function() {
    let answerTextField = $(this).closest('.input-group').find('.answer-text');
    let cardBody = answerTextField.closest('.survey-card-body');
    let notApplicableCheckbox = cardBody.find('.mark-not-applicable');
    answerTextField.val('');
    answerTextField.removeClass('filled').prop('readonly', false);
    answerTextField.data('skipValidation', true).change();
    notApplicableCheckbox.prop('checked', false);
  });

  // Copy previous data
  parentContainer.find('.copy-previous-answer').click(function() {
    let previousSurveyId = $(this).attr('data-previous-survey-id');
    let answerId = $(this).attr('data-answer-id');
    let params = {};
    params['previous_survey_id'] = previousSurveyId;
    params['answer_id'] = answerId;
    let url = "/" + accountUrl + "/surveys/" + surveySlug + "/answers/prefill?" + $.param(params);

    // Opacity on page
    $('.modal.prefill-modal').modal('hide');

    // Indicate should update included section
    let cardBody = $(this).closest('.card').find('.survey-card-body');
    let userId = cardBody.attr('data-user-id');
    cardBody.attr('data-val-changed', 'true');
    cardBody.find('.user-id').attr('value', userId);
    cardBody.find('.new-data').attr('value', true);

    // Submit
    $.ajax({
      type: "POST",
      dataType: "script",
      timeout: 3000,
      url: url
    })
  })

  // Mark not applicable
  parentContainer.find('.mark-not-applicable').click(function() {
    let el = $(this);
    let disabled = $(this).attr('disabled');
    if (disabled === "disabled") {return;}
    ToggleNewData(el);
    if (el.attr('data-selected') === 'true') {
      el.closest('.input-group').find('.answer-text').val('').removeClass('filled').change();
      el.removeClass('bg-gray100').addClass('bg-white').attr('data-selected', 'false');
      el.attr('data-original-title', 'Click to mark this question as not applicable. Please provide explanation in the comment if necessary.')
    } else {
      el.closest('.input-group').find('.answer-text').val('Not applicable').addClass('filled').change();
      el.closest('.question-row').removeClass('incomplete');
      el.removeClass('bg-white').addClass('bg-gray100').attr('data-selected', 'true');
      el.attr('data-original-title', 'Click to remove the \'Not applicable\' designation.')
    }
    el.tooltip('hide');
  });

  // Prefer not disclose
  parentContainer.find('.prefer-not-disclose').click(function() {
    let el = $(this);
    let disabled = $(this).attr('disabled');
    if (disabled === "disabled") {return;}
    ToggleNewData(el);
    if (el.attr('data-selected') === 'true') {
      el.closest('.input-group').find('.answer-text').val('').removeClass('filled').change();
      el.removeClass('bg-gray100').addClass('bg-white').attr('data-selected', 'false');
      el.attr('data-original-title', 'Click to mark \'Prefer not to disclose\'. Please provide explanation in the comment if necessary.')
    } else {
      el.closest('.input-group').find('.answer-text').val('Prefer not to disclose').addClass('filled').change();
      el.closest('.question-row').removeClass('incomplete');
      el.removeClass('bg-white').addClass('bg-gray100').attr('data-selected', 'true');
      el.attr('data-original-title', 'Click to remove the \'Prefer not to disclose\' designation.')
    }
    el.tooltip('hide');
  });

  // Filter typeaheads for documents
  SelectExistingDocument(parentContainerEl, parentContainer);

  // Set a source link
  AddSupportingLinks(parentContainer);

  // Blur on select
  parentContainer.find('.documents-typeahead').bind('typeahead:select', function(ev, suggestion) {
    $(this).typeahead("val", "");
    $(this).blur();
  });

  // On initial click of submit, check any validations
  CheckValidationsOnSubmit();

  // On submit
  $('#submitQuestionnaireResponse').click(function(el) {
    el.preventDefault();

    // Add field to form to indicate we're submitting it
    $('#hidden_submit_survey').val("true");
    $('#hidden_status').val('submitted');

    // Remove non-changed fields
    DisableUnchangedFields();

    // Submit form
    $('#hiddenSaveSurvey').click();

    // Change fields back to enabled
    EnableUnchangedFields();

  })

  // On submit
  $('.unsubmit-questionnaire-response').click(function(el) {
    el.preventDefault();

    // Confirm and then continue
    return Swal.fire({
      title: "Confirm",
      text: "Please confirm that you would like to change the status of this questionnaire back to 'draft'.",
      animation: false,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-light border',
        popup: 'animated fadeIn faster'
      }
    }).then((result) => {
      if (result.value) {
        
        // Add field to form to indicate we're submitting it
        $('#hidden_submit_survey').val("false");

        // Opacity on page
        $('#save_response_form .data-collection-content').css('opacity', 0.25)

        // Remove non-changed fields
        DisableUnchangedFields();

        // Submit form - first need to enable fields, otherwise rails UJS doesn't submit form
        $('input, select, textarea').attr('disabled', false);
        $('#hiddenSaveSurvey').click();

		    // Change fields back to enabled
		    EnableUnchangedFields();

      }
    });

  })

  // Update hidden fields on type of value/number text field
  parentContainer.find(".value-text").on("change paste keyup", function() {

    // skip for arrow keys
    if(event.which >= 37 && event.which <= 40) return;

    // Update related numeric input (remove comma, return to value)
    let numericInput = $(this).closest('.form-group').find('.numeric-hidden-field');
    let numericVal = parseFloat( $(this).val() );

    // Divide by 100 if percentage
    if ($(this).hasClass('number-percentage')) {
      numericVal = numericVal / 100;
    }

    // Update associated hidden field
    if (Number.isNaN(numericVal)) {
      numericInput.val('');
    } else {
      numericInput.val(numericVal);
    }

  });

  // Add percentage and cap amount if percentage
  parentContainer.find('.number-percentage').on("blur", function() {
    let currentVal = parseFloat( $(this).val() );
    if (Number.isNaN(currentVal)) {
      $(this).val('');
    } else {
      $(this).val(currentVal + '%');
    }
  });

  // Update commentary box on close of modal
  $('.commentary-container .modal').on('hidden.bs.modal', function() {
    let textarea = $(this).find('textarea');
    if (textarea.length === 0) {return;}
    let len = textarea.val();
    let container = $(this).closest('.commentary-container')
    let btn = container.find('.btn');
    if (len.length > 0) {
      btn.addClass('btn-light').removeClass('btn-white');
    } else {
      btn.addClass('btn-white').removeClass('btn-light');
    }
  })

  // Upload files
  AddDocuments(parentContainer);


}
